import NewProductSelection from '../NewProductSelection'

export default function ProductsSelection() {
  return <NewProductSelection />
}
